import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareChecklist: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-checklist, checklist box, check, list"><path d="M7.54296 9.49775L8.66796 10.2478L10.5396 7.75224M13.8079 9H16.3079M13.75 15H16.25M7.54296 15.4989L8.66796 16.2489L10.5396 13.7534M3.75 3.75H20.25V20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareChecklist;
